import React, { Component } from 'react';
import Textarea from 'react-textarea-autosize';
import { NumericSOEditor } from './NumericSOEditor';

export class Conflicts extends Component {
    displayName = Conflicts.name;

    constructor(props) {
        super(props);

        let d1 = new Date();
        d1.setDate(d1.getDate() - 1);
        let d2 = new Date();
        d2.setDate(d2.getDate() - 2);
        let d3 = new Date();
        d3.setDate(d3.getDate() - 3);
        let d4 = new Date();
        d4.setDate(d4.getDate() - 4);
        let d5 = new Date();
        d5.setDate(d5.getDate() - 5);
        let d6 = new Date();
        d6.setDate(d6.getDate() - 6);
        let d7 = new Date();
        d7.setDate(d7.getDate() - 7);

        this.state = {
            monthDayLabelTodayMinus1: (d1.getMonth() + 1).toString() + "/" + d1.getDate().toString(),
            monthDayLabelTodayMinus2: (d2.getMonth() + 1).toString() + "/" + d2.getDate().toString(),
            monthDayLabelTodayMinus3: (d3.getMonth() + 1).toString() + "/" + d3.getDate().toString(),
            monthDayLabelTodayMinus4: (d4.getMonth() + 1).toString() + "/" + d4.getDate().toString(),
            monthDayLabelTodayMinus5: (d5.getMonth() + 1).toString() + "/" + d5.getDate().toString(),
            monthDayLabelTodayMinus6: (d6.getMonth() + 1).toString() + "/" + d6.getDate().toString(),
            monthDayLabelTodayMinus7: (d7.getMonth() + 1).toString() + "/" + d7.getDate().toString()
        };
    }

    render() {
        return (
            <table className="table table-hover" id="tab_logic">
                <thead>
                    <tr>
                        <th>Description</th>
                        {this.props.orderGuideGroup.showBrand &&
                            <th>Brand</th>
                        }
                        {this.props.orderGuideGroup.showPricing &&
                            <th>Price</th>
                        }
                        {this.props.orderGuideGroup.showPastDelivery &&
                            <th colSpan="7" className="centerText">Past Delivery</th>
                        }
                        {this.props.orderGuideGroup.showComments &&
                            <th>OGC Comments</th>
                        }
                        {this.props.orderGuideGroup.showGroupBuyerNotes &&
                            <th>Group Comments</th>
                        }
                        {this.props.orderGuideGroup.showStoreComments &&
                            <th>Store Comments</th>
                        }
                        <th>Server Quantity</th>
                        <th>Total Order</th>
                    </tr>
                    <tr>
                        <th />
                        {this.props.orderGuideGroup.showBrand &&
                            <th />
                        }
                        {this.props.orderGuideGroup.showPricing &&
                            <th />
                        }
                        {this.props.orderGuideGroup.showPastDelivery &&
                            <React.Fragment>
                                <th>{this.state.monthDayLabelTodayMinus7}</th>
                                <th>{this.state.monthDayLabelTodayMinus6}</th>
                                <th>{this.state.monthDayLabelTodayMinus5}</th>
                                <th>{this.state.monthDayLabelTodayMinus4}</th>
                                <th>{this.state.monthDayLabelTodayMinus3}</th>
                                <th>{this.state.monthDayLabelTodayMinus2}</th>
                                <th>{this.state.monthDayLabelTodayMinus1}</th>
                            </React.Fragment>
                        }
                        <th colSpan="4" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.salesOrderItems.map((salesOrderItem, idx) => (
                        <tr key={salesOrderItem.productId}>
                            <td>{salesOrderItem.ogcDescription}</td>
                            {this.props.orderGuideGroup.showBrand &&
                                <td>{salesOrderItem.brand}</td>
                            }
                            {this.props.orderGuideGroup.showPricing &&
                                <td>{salesOrderItem.price}</td>
                            }
                            {this.props.orderGuideGroup.showPastDelivery &&
                                <React.Fragment>
                                    <td>{salesOrderItem.pdM7}</td>
                                    <td>{salesOrderItem.pdM6}</td>
                                    <td>{salesOrderItem.pdM5}</td>
                                    <td>{salesOrderItem.pdM4}</td>
                                    <td>{salesOrderItem.pdM3}</td>
                                    <td>{salesOrderItem.pdM2}</td>
                                    <td>{salesOrderItem.pdM1}</td>
                                </React.Fragment>
                            }
                            {this.props.orderGuideGroup.showComments &&
                                <td style={{ width: ((this.props.orderGuideGroup.showGroupBuyerNotes) ? '15%' : '25%') }}>{salesOrderItem.notes}</td>
                            }
                            {this.props.orderGuideGroup.showGroupBuyerNotes &&
                                <td style={{ width: ((this.props.orderGuideGroup.showGroupBuyerNotes) ? '15%' : '25%') }}>{salesOrderItem.groupBuyerNotes}</td>
                            }
                            {this.props.orderGuideGroup.showStoreComments &&
                                <td><Textarea tabIndex="-1" type="text" style={{ width: '100%', resize: 'vertical', padding: '3px' }} defaultValue={salesOrderItem.storeComments || ""} onBlur={this.props.updateRowComment(salesOrderItem)} /></td>
                            }
                            {!salesOrderItem.locked &&
                                <React.Fragment>
                                    <td style={{ paddingLeft: '10px' }}>
                                        {salesOrderItem.qtyToOrder}
                                    </td>
                                    <td>
                                        <NumericSOEditor
                                            onChange={this.props.updateConflictRowQuantity(salesOrderItem)}
                                            onKeyDown={this.props.updateConflictRowOnKeyDown(salesOrderItem)}
                                            value={(salesOrderItem.dirtyQtyToOrder === 0) ? "" : salesOrderItem.dirtyQtyToOrder}
                                        />
                                    </td>
                                </React.Fragment>
                            }
                            {salesOrderItem.locked &&
                                <React.Fragment>
                                    <td style={{ paddingLeft: '10px' }}>
                                        {salesOrderItem.qtyToOrder}
                                    </td>
                                    <td style={{ paddingLeft: '10px' }}>
                                        {salesOrderItem.dirtyQtyToOrder}
                                    </td>
                                </React.Fragment>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SalesOrder/Conflicts.js